import { t } from '@bia-auction/shared-i18n';
import { Loader2 } from 'lucide-react';
import { ApiError } from '../lib/api';

/** Centered spinner for loading states. */
export function Loading({ label }: { label?: string }) {
  return (
    <div className="flex items-center gap-2 py-8 text-sm text-muted-foreground">
      <Loader2 className="h-4 w-4 animate-spin" /> {label ?? t('common.loading')}
    </div>
  );
}

/** Inline error message for a failed query/action. Shows the server correlation id (M9, ADR 0023)
 * when the failure carries one, so a user can quote it to support — this is the common API-error
 * path (the ErrorBoundary only catches render crashes). */
export function ErrorMsg({ error }: { error: unknown }) {
  const message = error instanceof Error ? error.message : t('common.error');
  const requestId = error instanceof ApiError ? error.requestId : undefined;
  return (
    <div className="py-4 text-sm text-destructive">
      {message}
      {requestId && (
        <span className="mt-1 block text-xs text-muted-foreground">
          {t('common.errorBoundary.requestId')}: <code>{requestId}</code>
        </span>
      )}
    </div>
  );
}

/** Empty-state placeholder. */
export function Empty({ label }: { label: string }) {
  return <div className="py-8 text-center text-sm text-muted-foreground">{label}</div>;
}
